import { isDefined } from "./helper.utils";

export function parseIntSafe(value: string | undefined): number | undefined;
export function parseIntSafe(
    value: string | undefined,
    defaultValue: number
): number;
export function parseIntSafe(value: string | undefined, defaultValue?: number) {
    if (!isDefined(value)) return defaultValue;

    const parsed = parseInt(value, 10);

    return Number.isNaN(parsed) ? defaultValue : parsed;
}
